<mat-card appearance="outlined" *ngIf="reservation$ | async as reservation">
	<p mat-card-title>Status rezerwacji: {{ reservationStatus$ | async }}</p>
	<mat-card-content>
		<div class="row">
			<div class="col d-flex align-items-center gap-1">
				<span *ngIf="reservation">
					{{ statusMappings[reservation.status] ?? '' }}

					{{ statusTime$ | async | date: 'dd.MM.yyyy HH:mm' : 'pl-PL' }}
					<br />
					<ng-container *ngIf="reservation.status === Status.CONFIRMED && reservation.expirationTime">
						Czas opcji wynosił:
						{{ reservation.expirationTime | date: 'dd.MM.yyyy HH:mm' }}
					</ng-container>
				</span>
				<button mat-icon-button *ngIf="reservation.status === Status.OPTION" (click)="timeOpened = !timeOpened">
					<i class="fas fa-calendar-check fs-5 text-secondary"></i>
				</button>
				<span
					*ngIf="amountOfOptionTimeChanges$ | async as amount"
					matTooltip="Tyle razy został zmieniony czas opcji."
					class="bg-warning rounded-circle p-2 d-flex justify-content-center align-items-center"
					style="width: 30px; height: 30px"
				>
					{{ amount }}
				</span>
			</div>
			<div class="col">
				<p class="mb-0">Data założenia rezerwacji</p>
				<p class="mb-0">
					{{ reservationTime$ | async }}
				</p>
			</div>
		</div>
		<mat-card appearance="outlined" *ngIf="timeOpened" class="mt-3">
			<mat-card-subtitle class="mb-0">Zmień czas opcji</mat-card-subtitle>
			<mat-card-content>
				<div class="row">
					<div class="col">
						<mat-calendar [(selected)]="selectedDate" [dateFilter]="dateFilter"></mat-calendar>
					</div>
					<div class="col">
						<mat-form-field appearance="outline" style="width: 10px" class="invisible">
							<input
								matInput
								[format]="24"
								[ngxMatTimepicker]="pickerD"
								[(ngModel)]="selectedTime"
								readonly
								style="width: 0; height: 0"
								class="border-0 invisible"
							/>
						</mat-form-field>
						<button mat-raised-button color="primary" (click)="pickerD.open()">Wybierz godzinę</button>
						<div class="ngx-mtp-box-bordered">
							<ngx-mat-timepicker appendToInput="true" #pickerD></ngx-mat-timepicker>
						</div>
					</div>
				</div>
				<p
					class="text-bold position-absolute bottom-0 start-0 pb-3 ps-3"
					*ngIf="selectedTime && formattedSelectedDate$ | async as formattedSelectedDate"
				>
					Wybrano czas: {{ formattedSelectedDate }}
					{{ selectedTime }}
				</p>
			</mat-card-content>
			<mat-card-actions align="end">
				<button mat-flat-button (click)="timeOpened = false">Anuluj</button>
				<button
					mat-raised-button
					color="primary"
					[disabled]="!(selectedTime && selectedDate)"
					(click)="changeOptionTime()"
				>
					Zmień
				</button>
			</mat-card-actions>
		</mat-card>
		<button mat-icon-button [matMenuTriggerFor]="menu" class="position-absolute mt-3 top-0 end-0 statusMenuButton">
			<i class="fas fa-ellipsis-vertical fs-4"></i>
		</button>
		<mat-menu #menu="matMenu">
			<button
				mat-menu-item
				(click)="confirmReservation()"
				[disabled]="reservation.status === Status.CONFIRMED || (isReservationCancelled$ | async)"
			>
				<span>Potwierdź</span>
			</button>
			<button mat-menu-item (click)="timeOpened = true" [disabled]="reservation.status === Status.OPTION">
				<span>Opcja</span>
			</button>
			<button
				mat-menu-item
				(click)="showCancelDialog()"
				[disabled]="isReservationCancelled$ | async"
				class="cancelReservationButton"
			>
				<span>Anuluj</span>
			</button>
		</mat-menu>
	</mat-card-content>
</mat-card>
